import { PartOrder } from 'app/models/PartOrder';

const DIRECT_NOTIFICATION_TITLE = 'Nouvelle commande Direct';

function canUseElectronNotifications(): boolean {
  if (typeof window === 'undefined') {
    return false;
  }
  const electronApi = (window as any).electronAPI;
  return Boolean(window.platform?.isElectron && electronApi?.notifications?.show);
}

export async function notifyDirectPartOrders(orders: PartOrder[]): Promise<void> {
  if (!canUseElectronNotifications() || orders.length === 0) {
    return;
  }

  const electronApi = (window as any).electronAPI;
  if (!electronApi?.notifications?.show) {
    return;
  }
  const show = electronApi.notifications.show.bind(electronApi.notifications);
  for (const order of orders) {
    const segments: string[] = [`Commande ${order.identification}`];
    if (order.customerName) {
      segments.push(order.customerName);
    } else if (order.orderInfo?.description) {
      segments.push(order.orderInfo.description);
    }
    const body = segments.join(' · ');
    try {
      await show({ title: DIRECT_NOTIFICATION_TITLE, body });
    } catch (error) {
      // eslint-disable-next-line no-console
      console.warn('[notifications] Failed to show Electron notification', error);
    }
  }
}
